import { useContext } from 'react';
import useRakenneosaNavV2 from './services/useRakenneosaNavV2';
import RakenneosaNavView from './views/RakenneosaNavView';
import { ReportTemplateContext } from '../../ReportTemplate/ReportTemplateContext';
import { findLinkedProjectId } from '../../../../utils/ptsUtils';
import usePeitepaksuusV2 from './services/usePeitepaksuusV2';
import PeitepaksuusView from './views/PeitepaksuusView';
import ApiFeedbackBanner from './views/ApiFeedbackBanner';

// Calls useRakenneosaNavV2 directly (rather than through the shared
// RakenneosaPickerV2 wrapper) so this block's own data-fetching
// (usePeitepaksuusV2 below) keys off the SAME optimistic nav the tab/pill
// UI uses — see PoranayteBlockV2 for why (RakenneosaPickerV2 keeps its own
// private copy of this hook's optimistic state and never exposes it back
// up, so a block reading nav from `data.nav` directly saw instant tabs but
// stale table content).
export default function PeitepaksuusBlockV2({ data, onChange, card, tableStartNumber }) {
  const id_kiinteisto = card?.id_kiinteisto ?? null;
  const templateCtx = useContext(ReportTemplateContext);
  const linkedProjectId = findLinkedProjectId(templateCtx?.sections ?? []);
  const activeSectionName = templateCtx?.activeSection?.name ?? null;
  const navSvc = useRakenneosaNavV2(id_kiinteisto, data?.nav || {}, next => onChange({ ...data, nav: next }), linkedProjectId, activeSectionName);
  const nav = navSvc.nav;
  const svc = usePeitepaksuusV2(nav.rakId);

  return (
    <div>
      <RakenneosaNavView id_kiinteisto={id_kiinteisto} svc={navSvc} />
      <ApiFeedbackBanner feedback={svc.feedback} onClose={svc.clearFeedback} />
      {nav.rakId ? (
        <PeitepaksuusView {...svc} taulukkoNum={tableStartNumber ?? 1} />
      ) : nav.tkId && navSvc.rakenneosat.length === 0 && (
        // Without this the table area just went blank when switching to a
        // tarkastuskohde with no rakenneosa yet — easy to misread as "stuck
        // on the previous tarkastuskohde's table" since nothing visibly
        // changed to explain why it's empty. Same message as the
        // standalone taloyhtiökortti workspace's equivalent empty state.
        <div style={{ padding: '18px 4px', textAlign: 'center', color: '#8e8e93', fontSize: '0.84rem' }}>
          Lisää ensin rakenneosa yllä nähdäksesi taulukon.
        </div>
      )}
    </div>
  );
}
